var _path, _rect, _rect2, _rect3, _line, _line2, _rect4, _line3, _line4, _rect5, _line5, _line6, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitiesEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 174,
    viewBox: "0 0 449 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.537 0H190.736V9.87274H209.901V127.184H236.616V22.6492H288.883V60.3979H295.852V46.4599H309.79V60.3979H324.309V46.4599L361.477 58.8402V96.4044H381.222V127.184H402.71V134.153H381.222H361.477H352.766H336.505H324.309H309.79H295.852H288.883H274.945H236.616H209.901H190.736H165.183H160.537H151.826H123.37H121.047H111.174H105.366H77.4903H67.0369H46.1299V127.184H67.0369V112.085H77.4903V91.7584H105.366V112.085H111.174V73.7552V58.6557C111.174 51.9202 116.634 46.4599 123.37 46.4599C130.105 46.4599 135.565 51.9202 135.565 58.6557V73.7552H151.826V9.87274H160.537V0Z",
    fill: "#F4F7F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 173.148,
    y: 26.5,
    width: 41.8,
    height: 129.2,
    rx: 4,
    fill: "#212A35",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.55,
    y: 26.5,
    width: 91.2,
    height: 129.2,
    rx: 3.8,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198.977,
    y: 45.5,
    width: 14.9843,
    height: 14.9843,
    rx: 3.8,
    fill: "#68E4FF",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 47.348,
    x2: 258.91,
    y2: 47.348,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 58.5873,
    x2: 247.672,
    y2: 58.5873,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198.977,
    y: 82.9526,
    width: 14.9843,
    height: 14.9843,
    rx: 3.8,
    fill: "#68E4FF",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 84.8007,
    x2: 258.91,
    y2: 84.8007,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 96.0399,
    x2: 247.672,
    y2: 96.0399,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.977,
    y: 120.415,
    width: 14.9843,
    height: 14.9843,
    rx: 3.8,
    fill: "#68E4FF",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 122.263,
    x2: 258.91,
    y2: 122.263,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 225.195,
    y1: 133.502,
    x2: 247.672,
    y2: 133.502,
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 149.5,
    r: 19.1,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.264 164.157L291.264 171.157",
    stroke: "#212A35",
    strokeWidth: 3.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesEmptyStateIcon);
export default __webpack_public_path__ + "static/media/activitiesEmptyStateIcon.6f4c7e0b0286bdcb0f02b715ddb91499.svg";
export { ForwardRef as ReactComponent };